module.exports = __webpack_public_path__ + "10_2x.jpg?d546b62200503baaff39dfa2019ad736";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10_2x.jpg
// module id = 84
// module chunks = 0